<template>
  <DeepHeader />
  <NewModal
    :isOpen="isInitialized"
    absolute
  >
    <DeepLinkContent :title="routeTitleMap[route.name]" />
    <DeepLinkButton
      :deepLink="deepLink"
      :isAppInstalled="isAppInstalled || isToken"
      :isCheckSupported="isCheckSupported || isToken"
    />
    <StoreButton
      v-if="(!isAppInstalled || !isCheckSupported) && !isToken"
      :secondary="!isCheckSupported"
    />
  </NewModal>
</template>

<script setup>
import DeepLinkButton from '@/deepLinks/components/DeepLinkButton.vue';
import DeepLinkContent from '@/deepLinks/components/DeepLinkContent.vue';
import { DeepRoute, routeTitleMap } from '@/deepLinks/constants';
import { computed, onBeforeMount, ref } from 'vue';
import { useCheckProtocol } from '@/deepLinks/hooks/useCheckProtocol';
import StoreButton from '@/deepLinks/components/StoreButton/StoreButton.vue';
import NewModal from '@/shared/components/Modal/NewModals/NewModal.vue';
import DeepHeader from '@/deepLinks/components/DeepHeader.vue';
import { useRoute } from 'vue-router';
import { purifyLink } from '@/deepLinks/purifyLink';

const route = useRoute();
const isInitialized = ref(false);
const link = ref(purifyLink(location.href, ['token']));
const { isCheckSupported, isAppInstalled, deepLink, checkProtocol } = useCheckProtocol({ isInitialized, link });

const isToken = computed(() => route.name === DeepRoute.AUTH.name && route.query.token);

onBeforeMount(checkProtocol);
</script>
